<template>
	<div>
		<div class="navigationBg">
			<header class="navigation">
				<h1>
					<img class="logo" alt="筑橙科技" src="../resource/images/logo.svg">
				</h1>
				<nav class="navigator">
					<router-link to="/" class="navigatorText">首页
						<div class="block"></div>
					</router-link>
					<div @click="reminder()" class="navigatorText">产品中心
						<div class="block"></div>
					</div>
					<router-link class="navigatorText" to="/example01">应用案例
						<div class="block"></div>
					</router-link>
					<router-link to="/news01" class="navigatorText active">筑橙新闻
						<div class="block activeBlock"></div>
					</router-link>
					<router-link  to="/aboutUs" class="navigatorText">关于我们
						<div class="block"></div>
					</router-link>
					<div @click="open()" class="navigatorText">在线联系
						<div class="block"></div>
					</div>
				</nav>
			</header>
		</div>
		<div class="localhost">
			<div class="localhostText">首页/筑橙新闻/<span style="color:#333;">筑橙科技搭上“十四五”政策顺风车</span></div>
		</div>
		<div class="example">
			<h2 class="exampleTitle">“二合一”喷涂机器人上工啦</h2>
			<div class="exampleDate">2022年3月31日</div>
			<div class="exampleItemDiv">
				<div class="exampleItem">
					<div class="exampleItemTitle">
						<p class="text-indent-2em">
							2022年3月，筑橙科技全新升级的“二合一”智能喷涂机器人奔赴山东济宁工地现场，开工啦！
						</p>
						<p class="text-indent-2em">
							本次升级分为硬件和软件两部分。硬件上，主要是在机器人本体上预留了两套不同的供料系统接口，同一台机器人既可以喷涂乳液型外墙涂料，也可以喷涂颗粒型外墙涂料。软件上，进行了匹配升级，不同涂料的喷涂工艺均内嵌在软件系统中，操作员仅需在平板上做简单的点选即可实现不同涂料的自动化喷涂。
						</p>
						<p class="text-indent-2em">
							本次升级后，一台机器人可以实现从底漆到中涂、面漆、罩光的全体系外墙涂料的自动化喷涂，提高了机器人的适用性，大大节约了成本。
						</p>
					</div>
					<div class="exampleImgList">
						<div class="exampleImg">
							<img style="width:920px;height:auto;margin:0 auto;display:block;" src="../resource/images/img26.png">
						</div>
					</div>
					<div class="lineBlock"></div>
					<div class="exampleItemTitle">
						<p>顺势而为，乘势而上。展望未来，筑橙科技在“智能建造世界强国”长期战略目标及政府鼓励支持政策下，必将大有作为，发展前景广阔，未来可期。 筑橙科技致力于研发世界领先的建筑机器人，用机器人技术推动传统施工行业技术变革，为建筑施工产业提供智能施工解决方案。公司设有深圳、昆山两大研发中心，已在2021年实现外墙喷涂机器人的量产和产业化应用。</p>
					</div>
				</div>
			</div>
			<div class="getMore">

				<router-link to="/news" class="previous">上一篇：筑橙科技搭上“十四五”政策顺风车</router-link>
				<div class="next">下一篇：没有更多啦~</div>
			</div>
		</div>
		<foot></foot>
	</div>
</template>

<script>
	import foot from "../components/foot.vue"
	export default {
		components: {
			foot
		},
		name: 'news',
		data() {
			return {

			}
		},
		methods: {
			open(){
				window.open("http://qingflow.com/f/a445638c?qfchannel=Website")
				// window.location.href = "http://qingflow.com/f/a445638c?qfchannel=Website"
			},
			reminder() {
				this.hint.hint()
			}
		}
	}
</script>

<style scoped>
	.lineBlock{
		background-color:#194c7f;
		height:2px;
		margin:49px auto 50px auto;
		border-radius:2px;
	}
	.special {
		font-weight: 700;
		color: #1f5183;
	}

	.next {
		font-size: 12px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #999999;
		line-height: 12px;
		letter-spacing: 0.58px;
		margin-top: 10px;
		margin-bottom: 100px;
		display: block;
	}

	.previous {
		font-size: 12px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #999;
		line-height: 12px;
		letter-spacing: 0.58px;
		display: block;
	}

	.previous:hover {
		color: #194c7f;
	}

	.lastHint {
		margin: 50px auto;
		font-size: 16px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #707070;
		line-height: 26px;
		letter-spacing: 0.77px;
	}

	.exampleItemTitle {
		margin-top: 50px;
		font-size: 16px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		/* color: #707070; */
		color: #666;
		line-height: 26px;
		letter-spacing: 0.77px;
		margin-bottom: 30px;
	}

	.hint {
		margin-top: 15px;
		line-height: 28px;
		font-size: 20px;
		font-family: PingFang SC, PingFang SC-Bold;
		font-weight: 700;
		text-align: center;
		color: #333;
	}

	.exampleImgList {
		display: flex;
		justify-content: space-around;
	}

	.exampleImg {
		width: 100%;
		margin-right: 45px;
	}

	.exampleImg:nth-last-child(1) {
		margin-right: 0;
	}

	.exampleDate {
		margin-top: 30px;
		line-height: 22px;
		font-size: 16px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #bbb;
		padding-bottom: 30px;
		box-sizing: border-box;
		border-bottom: 1px solid #eee;
	}

	.example {
		width: 1040px;
		margin: 0 auto;
		overflow: hidden;
	}

	.exampleTitle {
		margin-top: 70px;
		line-height: 42px;
		font-size: 30px;
		font-family: PingFang SC, PingFang SC-Bold;
		font-weight: 700;
		text-align: left;
		color: #333;
	}

	.localhostText {
		width: 1040px;
		line-height: 42px;
		font-size: 30px;
		font-family: PingFang SC, PingFang SC-Bold;
		font-weight: 700;
		text-align: left;
		color: #333;
		margin: 0 auto;
	}

	.localhost {
		height: 85px;
		display: flex;
		align-items: center;
		background-color: #f6f7f7;
	}

	.localhostText {
		width: 1200px;
		margin: 0 auto;
		font-size: 18px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		text-align: left;
		color: #999;
	}

	.title {
		line-height: 56px;
		font-size: 40px;
		font-family: PingFang SC, PingFang SC-Heavy;
		font-weight: 800;
		text-align: left;
		color: #333;
		margin-top: 60px;
	}

	.logo {
		width: 154px;
		height: 38px;
	}

	.navigation {
		width: 1200px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.navigator {
		display: flex;
		align-items: center;
	}

	.navigatorText {
		line-height: 25px;
		font-size: 18px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		color: #fff;
		margin-left: 60px;
		cursor: pointer;
		transition: all .3s;
		position: relative;
	}

	.navigatorText:nth-child(1) {
		margin-left: 0px;
	}

	.navigatorText:hover {
		color: #EA5B24;
	}

	.block {
		position: absolute;
		/* width: 33px; */
		width: 100%;
		height: 2px;
		background-color: #fff;
		transition: all .3s;
		left: 0;
		bottom: -5px;
		opacity: 0;
	}

	.navigatorText:hover .block {
		background-color: #EA5B24;
		opacity: 1;
	}

	.navigationBg {
		width: 100%;
		background-color: rgba(0, 0, 0, 0.66);
		display: flex;
		justify-content: center;
		/* position: absolute;
		left: 0;
		top: 0; */
	}

	.navigatorText {
		color: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/pages/news02.vue